import axiosInstance from "../api/axiosInstance";
import clientAxiosInstance from "../api/clientAxiosInstance";

export const fetchRelationshipSuggestion = async ({
  householdId,
  householdMemberId,
  accountId,
  counterpartyMemberId,
  clientToken = null,
}) => {
  if (!householdId || !householdMemberId) {
    return { relationship: null };
  }
  const params = new URLSearchParams({
    household_member_id: householdMemberId,
  });
  if (accountId) params.set("account_id", accountId);
  if (counterpartyMemberId) params.set("counterparty_member_id", counterpartyMemberId);
  try {
    if (clientToken) {
      const res = await clientAxiosInstance.get(
        `/client/household/${householdId}/relationship-suggestion?${params.toString()}`,
        { headers: { Authorization: `Bearer ${clientToken}` } },
      );
      return res.data || { relationship: null };
    }
    const res = await axiosInstance.get(
      `/households/${householdId}/relationship-suggestion?${params.toString()}`,
    );
    return res.data || { relationship: null };
  } catch (e) {
    return { relationship: null };
  }
};
